import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Main.css';

const Policy = () => {
    const navigate = useNavigate();
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
    const handleResize = () => {
        setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goToGallery = () => {
        navigate('/pages/gallery')
    }

    const goToAbout = () => {
        navigate('/pages/about')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    return(
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 8px",}}>
            {size.width > 768 && 
            <div style={{display: "flex", justifyContent: "center", gap: 32, marginBottom: 96}}>
                <div onClick={goToGallery} className="nav-item">GALLERY</div>
                <div onClick={goToAbout} className="nav-item">ABOUT</div>
                <div onClick={goToContact} className="nav-item">CONTACT</div>
            </div>}
            <div style={{fontSize: 32, fontWeight: 600, marginBottom: 64}}>
                개인정보처리방침
            </div>
            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, fontSize: 15, fontWeight: 500, whiteSpace: "pre-line",}}>
                {'" 회사명"(이하 "회사"라 함)는 회사가 운영하는"사이트"(이하 "사이트"라 함)를 이용하는 이용자들의 개인정보보호를 매우 중요시하며, 이용자가 회사의 웹서비스(이하 "서비스"라 함)를 이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고 있습니다. 이에 회사는 통신비밀보호법, 전기통신사업법, 정보통신망이용촉진등에관한법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한 개인정보보호지침을 준수하고 있습니다. 회사는 개인정보 보호정책을 통하여 이용자들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.\n\n회사는 개인정보 보호정책을 사이트 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다.\n\n회사의 개인정보 보호정책은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 보호정책의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고 개인정보 보호정책을 개정하는 경우 회사는 그 변경사항에 대하여 즉시 사이트를 통하여 게시하고 버전번호 및 개정일자 등을 부여하여 개정된 사항을 이용자들이 쉽게 알아볼 수 있도록 하고 있습니다. 이용자들께서는 사이트 방문시 수시로 확인하시기 바랍니다.\n\n회사의 개인정보 보호정책은 다음과 같은 내용을 담고 있습니다.\n\n가. 개인정보 수집에 대한 동의\n나. 개인정보의 수집목적 및 이용목적\n다. 개인정보 항목 및 수집방법\n라. 개인정보의 보유 및 이용기간\n마. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항\n바. 쿠키(cookie)의 운영에 관한 사항\n사. 개인정보관련 기술적-관리적 대책'}
            </div>
        </div>
    )
}

export default Policy;